import DownloadReport from "../DownloadReport";
import AddOpsManager from "./addOpsManager";
import AllOpsManager from "./allOpsManager";

function OpsManager() {
  return (
    <>
      <h1>Welcome to Ops Manager Management</h1>
      <AddOpsManager role={"OPERATION_MANAGER"}/>
      <DownloadReport />
      <AllOpsManager  role={"OPERATION_MANAGER"}/>
    </>
  );
}

export default OpsManager